import request from "@/utils/request.js";
import { dataEncrypt } from '@/utils/DataEncrypt';

// 登录方法
export function login(username, password, code, uuid) {
  const data = {
    username,
    password: password, //dataEncrypt(password)
    code,
    uuid,
  };
  return request({
    url: process.env.VUE_APP_RUOYI_API + "/login",
    headers: {
      isToken: false,
    },
    method: "post",
    data: data,
  });
}

// 注册方法
export function register(data) {
  return request({
    url: process.env.VUE_APP_RUOYI_API + "/register",
    headers: {
      isToken: false,
    },
    method: "post",
    data: data,
  });
}

// 获取用户详细信息
export function getInfo() {
  return request({
    url: process.env.VUE_APP_RUOYI_API + "/getInfo",
    method: "get",
  });
}

// 人员企业信息查询
export function getUserId(userName, deptId) {
  return request({
    url: `/company/manage/detailByPhoneNum?phoneNum=${userName}&ryDeptId=${deptId}`,
    method: "get",
  });
}

// 退出方法
export function logout() {
  return request({
    url: process.env.VUE_APP_RUOYI_API + "/logout",
    method: "post",
  });
}

// 获取验证码
export function getCodeImg() {
  return request({
    url: process.env.VUE_APP_RUOYI_API + "/captchaImage",
    headers: {
      isToken: false,
    },
    method: "get",
    timeout: 20000,
  });
}
